<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="标题"
        prop="title"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.title"
          placeholder="请输入"
          @change="(value)=>{form.title = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="类型"
        prop="type"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.type"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="(v,k) in dicts.previewType"
            :key="k"
            :label="v"
            :value="k"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="图片"
        style="margin-right:15px"
        :required="true"
      >
        <ImgUpload
          :upload-config="{ lebal: '预览图片', prefix: 'img', form, suffix: '', modal: false }"
          :parent-data="{ isDetail: false }"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import ImgUpload from "@/components/ImgUpload";

export default {
  name: 'PreviewAdd',
  components: {
    ImgUpload
  },
  data() {
    return {
      dicts: { previewType: {}},
      form: {
        code: '',
        branchCode: '',
        title: '',
        img: '',
        typeName: '',
        type: '',
        url: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在 1 到 255个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form
          request({ url: '/ntocc-basic-api/preview', method: 'post', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherAddMethod')
          }).then(() => this.$refs['form'].resetFields())
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    },
    init() {
      // this.dicts = dicts
      this.getType()
      this.form = {
        title: '',
        img: '',
        type: ''
      }
      this.$refs['form'].resetFields()
    },
    getType(){
      this.dicts.previewType = {}
      let previewType = {}
      return request({
        url: `/ntocc-basic-api/dict/getPreviewType4Add`,
        method: 'get'
      }).then(res => {
        if (res.status === 0) {
          const list = res.data
          if (list && list.length > 0) {
            for (const i in list) {
              previewType[list[i].code] = list[i].name
            }
          }
        }
        this.$set(this.dicts,'previewType', previewType)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
